import React from 'react';
import axios from 'axios';
import $ from 'jquery';
import moment from 'moment';
import numeral from 'numeral';
import trans from '../../translations';
import Modelizer from 'ryvendor/Ry/Core/Modelizer';
import Item from './Item';
import './List.scss';

class List extends React.Component
{
    constructor(props)
    {
        super(props);

        const receivedData =
            props.data && props.data.data
                ? props.data.data
                : {};

        const receivedFilter =
            props.data && props.data.filter
                ? props.data.filter
                : {};

        this.state = {
            loading: false,
            data: Array.isArray(receivedData.data)
                ? receivedData.data
                : [],
            current_page: receivedData.current_page || 1,
            last_page: receivedData.last_page || 1,
            total: receivedData.total || 0,
            total_pieces: 0,
            total_weight: 0,
            filter: {
                cjid: receivedFilter.cjid || '',
                station: receivedFilter.station || '',
                cardit_number: receivedFilter.cardit_number || '',
                receptacle_id: receivedFilter.receptacle_id || '',
                date_from:
                    receivedFilter.date_from ||
                    moment().subtract(13, 'days').format('YYYY-MM-DD'),
                date_to:
                    receivedFilter.date_to ||
                    moment().format('YYYY-MM-DD'),
                delivery_scan_received:
                    receivedFilter.delivery_scan_received !== undefined
                        ? receivedFilter.delivery_scan_received
                        : ''
            },
            errors: []
        };

        this.request = null;

        this.calculateTotals = this.calculateTotals.bind(this);
        this.loadData = this.loadData.bind(this);
        this.searchTextField = this.searchTextField.bind(this);
        this.changeTextFilter = this.changeTextFilter.bind(this);
        this.handleScanStatusChange = this.handleScanStatusChange.bind(this);
        this.handleDateFromChange = this.handleDateFromChange.bind(this);
        this.handleDateToChange = this.handleDateToChange.bind(this);
        this.reset = this.reset.bind(this);
        this.renderPagination = this.renderPagination.bind(this);
        this.handleItemDeleted = this.handleItemDeleted.bind(this);
    }

    handleItemDeleted(id)
    {
        const remainingRows = this.state.data.filter(
            function (item) {
                return item.id !== id;
            }
        );

        if (
            remainingRows.length === 0 &&
            this.state.current_page > 1
        ) {
            this.loadData(this.state.current_page - 1);
            return;
        }

        this.setState({
            data: remainingRows,
            total: Math.max(this.state.total - 1, 0)
        }, function () {
            this.calculateTotals(remainingRows);
        });
    }
    
    componentDidMount()
    {
        this.calculateTotals(this.state.data);

        const options = {
            language: 'fr',
            autoclose: true
        };

        const dateFromPicker = $(this.refs.datepicker_from).datepicker(options);
        const dateToPicker = $(this.refs.datepicker_to).datepicker(options);

        dateFromPicker.on('changeDate', this.handleDateFromChange);
        dateToPicker.on('changeDate', this.handleDateToChange);
    }

    componentWillUnmount()
    {
        if (this.request && this.request.abort) {
            this.request.abort();
        }

        if (this.refs.datepicker_from) {
            $(this.refs.datepicker_from).datepicker('destroy');
        }

        if (this.refs.datepicker_to) {
            $(this.refs.datepicker_to).datepicker('destroy');
        }
    }

    calculateTotals(rows)
    {
        let pieces = 0;
        let weight = 0;

        rows.map(function (item) {
            pieces += parseInt(item.pieces || 0, 10);
            weight += parseFloat(item.total_weight || 0);
            return item;
        });

        this.setState({
            total_pieces: pieces,
            total_weight: weight
        });
    }

    changeTextFilter(event)
    {
        const name = event.target.name;
        const value = event.target.value;

        this.setState(function (state) {
            state.filter[name] = value;
            return state;
        });
    }

    searchTextField(field)
    {
        this.loadData(1, field);
    }

    handleScanStatusChange(event)
    {
        const value = event.target.value;

        this.setState(function (state) {
            state.filter.delivery_scan_received = value;
            return state;
        }, function () {
            this.loadData(1);
        });
    }

    handleDateFromChange()
    {
        const date = moment(
            $(this.refs.datepicker_from).datepicker('getDate')
        ).format('YYYY-MM-DD');

        this.setState(function (state) {
            state.filter.date_from = date;
            return state;
        }, function () {
            this.loadData(1);
        });
    }

    handleDateToChange()
    {
        const date = moment(
            $(this.refs.datepicker_to).datepicker('getDate')
        ).format('YYYY-MM-DD');

        this.setState(function (state) {
            state.filter.date_to = date;
            return state;
        }, function () {
            this.loadData(1);
        });
    }

    reset()
    {
        const filter = {
            cjid: '',
            station: '',
            cardit_number: '',
            receptacle_id: '',
            date_from: moment().subtract(13, 'days').format('YYYY-MM-DD'),
            date_to: moment().format('YYYY-MM-DD'),
            delivery_scan_received: ''
        };

        this.setState({filter: filter}, function () {
            $(this.refs.datepicker_from).datepicker(
                'setDate',
                moment(filter.date_from).toDate()
            );

            $(this.refs.datepicker_to).datepicker(
                'setDate',
                moment(filter.date_to).toDate()
            );

            this.loadData(1);
        });
    }

    loadData(page)
    {
        const self = this;

        if (self.request && self.request.abort) {
            self.request.abort();
        }

        self.setState({
            loading: true,
            data: [],
            total: 0,
            errors: []
        });

        self.request = axios.get('/inboundcjids', {
            params: {
                json: true,
                page: page,
                cjid: self.state.filter.cjid,
                station: self.state.filter.station,
                cardit_number: self.state.filter.cardit_number,
                receptacle_id: self.state.filter.receptacle_id,
                date_from: self.state.filter.date_from,
                date_to: self.state.filter.date_to,
                delivery_scan_received:
                    self.state.filter.delivery_scan_received
            },
            cancelToken: new axios.CancelToken(function (cancel) {
                self.request = {
                    abort: cancel
                };
            })
        })
        .then(function (response) {
            const payload = response.data && response.data.data
                ? response.data.data
                : response.data;

            const rows = payload && Array.isArray(payload.data)
                ? payload.data
                : [];

            self.setState({
                loading: false,
                data: rows,
                current_page: payload.current_page || 1,
                last_page: payload.last_page || 1,
                total: payload.total || 0
            }, function () {
                self.calculateTotals(rows);
            });
        })
        .catch(function (error) {
            if (axios.isCancel && axios.isCancel(error)) {
                return;
            }

            let message = trans('La recherche a échoué.');

            if (
                error.response &&
                error.response.data &&
                error.response.data.message
            ) {
                message = error.response.data.message;
            }

            self.setState({
                loading: false,
                data: [],
                current_page: 1,
                last_page: 1,
                total: 0,
                total_pieces: 0,
                total_weight: 0,
                errors: [message]
            });
        });
    }

    renderTextSearch(name, placeholder, columnClass, maxLength)
    {
        const self = this;

        return <div className={columnClass}>
            <div className="align-items-baseline d-flex form-group ml-2">
                <div className="input-group">
                    <input
                        type="search"
                        name={name}
                        placeholder={trans(placeholder)}
                        value={this.state.filter[name]}
                        maxLength={maxLength || null}
                        className="form-control text-uppercase"
                        onChange={this.changeTextFilter}
                        onKeyDown={function (event) {
                            if (event.keyCode === 13) {
                                event.preventDefault();
                                self.searchTextField(name);
                            }
                        }}
                    />
                    <div className="input-group-append">
                        <button
                            className="btn btn-primary"
                            type="button"
                            onClick={function () {
                                self.searchTextField(name);
                            }}
                            disabled={this.state.loading}
                        >
                            {trans('OK')}
                        </button>
                    </div>
                </div>
            </div>
        </div>;
    }

    renderPagination()
    {
        const self = this;

        return <React.Fragment>
            <a
                href="#"
                onClick={function (event) {
                    event.preventDefault();
                    self.loadData(1);
                }}
                className={this.state.current_page === 1 ? 'disabled' : ''}
            >
                <i className="fa fa-angle-double-left"></i>
            </a>

            <a
                href="#"
                onClick={function (event) {
                    event.preventDefault();
                    self.loadData(self.state.current_page - 1);
                }}
                className={this.state.current_page === 1 ? 'disabled' : ''}
            >
                <i className="fa fa-angle-left"></i>
            </a>

            <a
                href="#"
                onClick={function (event) {
                    event.preventDefault();
                    self.loadData(self.state.current_page + 1);
                }}
                className={
                    this.state.current_page === this.state.last_page
                        ? 'disabled'
                        : ''
                }
            >
                <i className="fa fa-angle-right"></i>
            </a>

            <a
                href="#"
                onClick={function (event) {
                    event.preventDefault();
                    self.loadData(self.state.last_page);
                }}
                className={
                    this.state.current_page === this.state.last_page
                        ? 'disabled'
                        : ''
                }
            >
                <i className="fa fa-angle-double-right"></i>
            </a>
        </React.Fragment>;
    }

    render()
    {
        const self = this;
        const pagination = this.renderPagination();

        return <div className="cardit-container vol-liste inbound-cjid-list col-md-12">
            <div className="row clearfix align-items-stretch position-relative vol-container">
                <div className="col-12">
                    <div className="topContainer mb-2 d-flex justify-content-between align-items-center">
                        <div className="col-md-12">
                            <div className="align-items-baseline row">
                                {this.renderTextSearch(
                                    'cjid',
                                    'Code CJID',
                                    'col-md-3'
                                )}

                                {this.renderTextSearch(
                                    'station',
                                    'Station',
                                    'col-md-2',
                                    3
                                )}

                                {this.renderTextSearch(
                                    'cardit_number',
                                    'Numéro CARDIT',
                                    'col-md-3'
                                )}

                                {this.renderTextSearch(
                                    'receptacle_id',
                                    'Receptacle ID',
                                    'col-md-4',
                                    29
                                )}
                            </div>

                            <div className="align-items-baseline row">
                                <div className="col-md-8 border rounded p-2">
                                    <div className="d-flex align-items-center">
                                        <div
                                            ref="datepicker_from"
                                            className="input-group date mx-2"
                                        >
                                            <input
                                                type="text"
                                                className="form-control"
                                                readOnly
                                                value={moment(
                                                    this.state.filter.date_from
                                                ).format('DD/MM/YYYY')}
                                            />
                                            <div className="input-group-append">
                                                <button
                                                    className="btn-primary btn text-light"
                                                    type="button"
                                                >
                                                    <i className="fa fa-calendar-alt"></i>
                                                </button>
                                            </div>
                                        </div>

                                        <div className="form-group m-auto">
                                            <label className="control-label mx-2 mb-0">
                                                {trans('au')}
                                            </label>
                                        </div>

                                        <div
                                            ref="datepicker_to"
                                            className="input-group date mx-2"
                                        >
                                            <input
                                                type="text"
                                                className="form-control"
                                                readOnly
                                                value={moment(
                                                    this.state.filter.date_to
                                                ).format('DD/MM/YYYY')}
                                            />
                                            <div className="input-group-append">
                                                <button
                                                    className="btn-primary btn text-light"
                                                    type="button"
                                                >
                                                    <i className="fa fa-calendar-alt"></i>
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div className="col-md-2">
                                    <div className="align-items-baseline d-flex form-group ml-2">
                                        <button
                                            type="button"
                                            className="btn btn-secondary w-100"
                                            onClick={this.reset}
                                            disabled={this.state.loading}
                                        >
                                            {trans('Réinitialiser')}
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>

                    {this.state.errors.length > 0
                        ? <div className="alert alert-danger">
                            {this.state.errors.join(' ')}
                        </div>
                        : null}

                    <div className="card overflowhidden">
                        <div className="body">
                            <div className="row m-0 justify-content-between">
                                <ul className="list list-inline mb-0">
                                    <li className="list-inline-item mr-3">
                                        <h6 style={{fontWeight: 'bolder'}}>
                                            {trans('INBOUND CJID')}
                                        </h6>
                                    </li>
                                    <li className="list-inline-item mr-3">
                                        {trans('Nombre de CJID')} :
                                        <strong className="ml-1">
                                            {this.state.total}
                                        </strong>
                                    </li>
                                    <li className="list-inline-item mr-3">
                                        {trans('Nombre de récipients')} :
                                        <strong className="ml-1">
                                            {this.state.total_pieces}
                                        </strong>
                                    </li>
                                    <li className="list-inline-item mr-3">
                                        {trans('Poids total')} :
                                        <strong className="ml-1">
                                            {numeral(
                                                this.state.total_weight
                                            ).format('0,0.00')} {trans('Kg')}
                                        </strong>
                                    </li>
                                </ul>
                            </div>

                            <div className="card-bureau no-border p-0">
                                <div className="table-responsive">
                                    <table
                                        className="table table-bordered table-hover table-striped table-liste"
                                        cellSpacing="0"
                                        cellPadding="0"
                                    >
                                        <thead>
                                            <tr>
                                                <th>{trans('Date')}</th>
                                                <th>{trans('CJID')}</th>
                                                <th>{trans('Station')}</th>
                                                <th>{trans('Carrier')}</th>
                                                <th>{trans('Nb pièces')}</th>
                                                <th>{trans('Total kg')}</th>
                                                <th>{trans('CJID scan received')}</th>
                                            </tr>
                                        </thead>

                                        <tbody>
                                            {this.state.data.length > 0
                                                ? this.state.data.map((item) => (
                                                    <Item
                                                        key={'inbound-cjid-' + item.id}
                                                        data={item}
                                                        onDeleted={self.handleItemDeleted}
                                                    />
                                                ))
                                                : <tr>
                                                    <td
                                                        colSpan="7"
                                                        className="text-center py-4"
                                                    >
                                                        {this.state.loading
                                                            ? <i className="fas fa-spinner fa-spin"></i>
                                                            : trans('Aucun résultat')}
                                                    </td>
                                                </tr>}
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>

                </div>
            </div>
        </div>;
    }
}

Modelizer(List);

export default List;
